/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Allocation_Form_Update_AllocationInputs */

const en_admin_allocation_form_update_allocation = /** @type {(inputs: Admin_Allocation_Form_Update_AllocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update Allocation`)
};

const de_admin_allocation_form_update_allocation = /** @type {(inputs: Admin_Allocation_Form_Update_AllocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zuweisung aktualisieren`)
};

const es_admin_allocation_form_update_allocation = /** @type {(inputs: Admin_Allocation_Form_Update_AllocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizar asignación`)
};

const fr_admin_allocation_form_update_allocation = /** @type {(inputs: Admin_Allocation_Form_Update_AllocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mettre à jour l'attribution`)
};

/** @type {(inputs: Admin_Allocation_Form_Update_AllocationInputs) => LocalizedString} */
const it_admin_allocation_form_update_allocation = en_admin_allocation_form_update_allocation;

/** @type {(inputs: Admin_Allocation_Form_Update_AllocationInputs) => LocalizedString} */
const pt_br2_admin_allocation_form_update_allocation = en_admin_allocation_form_update_allocation;

/** @type {(inputs: Admin_Allocation_Form_Update_AllocationInputs) => LocalizedString} */
const pl_admin_allocation_form_update_allocation = en_admin_allocation_form_update_allocation;

/** @type {(inputs: Admin_Allocation_Form_Update_AllocationInputs) => LocalizedString} */
const hu_admin_allocation_form_update_allocation = en_admin_allocation_form_update_allocation;

/** @type {(inputs: Admin_Allocation_Form_Update_AllocationInputs) => LocalizedString} */
const ro_admin_allocation_form_update_allocation = en_admin_allocation_form_update_allocation;

/**
* | output |
* | --- |
* | "Update Allocation" |
*
* @param {Admin_Allocation_Form_Update_AllocationInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_allocation_form_update_allocation = /** @type {((inputs?: Admin_Allocation_Form_Update_AllocationInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Allocation_Form_Update_AllocationInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_allocation_form_update_allocation(inputs)
	if (locale === "de") return de_admin_allocation_form_update_allocation(inputs)
	if (locale === "es") return es_admin_allocation_form_update_allocation(inputs)
	if (locale === "fr") return fr_admin_allocation_form_update_allocation(inputs)
	if (locale === "it") return it_admin_allocation_form_update_allocation(inputs)
	if (locale === "pt-BR") return pt_br2_admin_allocation_form_update_allocation(inputs)
	if (locale === "pl") return pl_admin_allocation_form_update_allocation(inputs)
	if (locale === "hu") return hu_admin_allocation_form_update_allocation(inputs)
	return ro_admin_allocation_form_update_allocation(inputs)
});
export { admin_allocation_form_update_allocation as "admin.allocation_form.update_allocation" }